import { BarChart3 } from "lucide-react";

export default function StatCard({
  title,
  value,
  icon,
  change,
  changeType = "positive", // positive | neutral | negative
  chart,
  subtitle
}) {

  if (!icon) {
    icon = { Icon: BarChart3, color: "gray" };
  }
  return (
    <div className="stat-card">
      <div className="stat-card-header">
        <div className={`stat-icon ${icon.color}`}>
          {icon.Icon ? <icon.Icon size={20} strokeWidth={2} /> : <i className={icon.class}></i>}
        </div>
        <div className="stat-title">{title}</div>
      </div>

      <div className="stat-value">{value}</div>

      {subtitle && <div className="stat-subtitle">{subtitle}</div>}
      {chart && <div className="stat-chart">{chart}</div>}

      {change !== undefined && (
        <div className={`stat-change ${changeType}`}>
          {changeType === "positive" && "+"}
          {change}%
        </div>
      )}
    </div>
  );
}
